import request from "@/utils/request";
import Qs from "qs";

const api = {
  findAllScreen: "/api/screen/find-all-screen",
  findByUser: "/api/screen/find-by-user",
  save: "/api/screen/save",
  findByRole: "/api/screen/find-by-role",
  del: "/api/screen/del-screen"
};

/**
 * 查询所有菜单
 * @param {*} parameter
 */
export function findAll(parameter) {
  return request({
    url: api.findAllScreen,
    method: "get",
    params: parameter
  });
}

/**
 * 获取用户的菜单
 * @param {*} parameter
 */
export function findByUser(parameter) {
  return request({
    url: api.findByUser,
    method: "get",
    params: parameter
  });
}

/**
 * 保存/修改菜单
 * @param {*} parameter
 */
export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 删除菜单
 * @param {*} parameter
 */
export function del(parameter) {
  return request({
    url: api.del,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

export function findByRole(parameter) {
  return request({
    url: api.findByRole,
    method: "get",
    params: parameter
  });
}
